let utils = require('../../../actions/utils');
let footer = require('../../../actions/layout/footer');
let auth = require('../../../actions/auth');
let analytics = require('../../../actions/analytics');
let error = require('../../../actions/error');

module.exports = [
    analytics.parseUtmFromQuery,
    utils.set('layout', 'auth'),
    auth.setComputedFields,
    analytics.pageview,
    footer.setCopyrightYear,
    error.passportError('page passport-error')
];



// WEBPACK FOOTER //
// ./signals/pages/auth/passport-error.js